export default __webpack_public_path__ + "static/media/calculator.53d046ca.svg";